/* eslint-disable simple-import-sort/imports */
import React from "react";

import "../../styles/base.scss";
// import "../../components/splitView/split.scss";
import DragAndDropContainer from "../../components/dragAndDrop/DragAndDropContainer";

import LeftPanel from "../../components/leftPanel";
import Workspace from "../workspace";
import Toolbar from "../toolbar";
import Footer from "../footer";
import SearchPanel from "../searchPanel";
import FilterPanel from "../filterPanel";
import SyncBinder from "../syncBinder";
import CalendarMarkerList from "../calendarMarkerList";
import Sidebar from "../sidebar";
import NotificationPanel from "../notificationPanel";
import Inspector from "../inspector";
import CalendarMarkerInspector from "../calendarMarkerInspector";
import SettingsModal from "../settingsModal";
import SyncSettingsModal from "../syncSettingsModal";
import PreferencesModal from "../preferencesModal";
import BackupModal from "../backupModal";
import AboutModal from "../aboutModal";
import ExportTsfModal from "../exportTsfModal";
import ExportCsvModal from "../exportCsvModal";
import ImportCsvModal from "../importCsvModal";
import SaveTemplateModal from "../saveTemplateModal";
import UpdateModal from "../updateModal";
import InspectorModal from "../inspector/InspectorModal";
import SampleModal from "../sampleModal";
import SettingsPanel from "../settingsModal/settingsPanel";
//#!if harvard === true
import HarvardSettingsPanel from "../settingsModal/harvardSettingsPanel";
//#!endif
import ConstraintPanel from "../constraintPanel";
import ScrollToDatePanel from "../scrollToDatePanel";
import TutorialPanel from "../tutorialPanel";
import TutorialNotification from "../tutorialPanel/TutorialNotification";

import PubSub from "pubsub-js";
import PubSubTopics from "../../constants/pubSubTopics";

import { map, isNil } from "lodash";

import SplitView from "../../components/splitView";
import selectors from "./selectors";

// SVG images
import SVGInline from "react-svg-inline";
import footerIcons from "../../svg/footerIcons.svg";
import inspectorIcons from "../../svg/inspectorIcons.svg";
import interfaceIcons from "../../svg/interfaceIcons.svg";
import statusIcons from "../../svg/statusIcons.svg";
import markerIcons from "../../svg/markerIcons.svg";
import sidebarIcons from "../../svg/sidebarIcons.svg";
import toolbarIcons from "../../svg/toolbarIcons.svg";
import typeIcons from "../../svg/typeIcons.svg";
import workviewIcons from "../../svg/workviewIcons.svg";
import settingsIcons from "../../svg/settingsIcons.svg";
import syncIcons from "../../svg/syncIcons.svg";
import templateIcons from "../../svg/templateIcons.svg";
import windowControlIcons from "../../svg/windowControlIcons.svg";
import emptyState from "../../svg/EmptyState.svg";
import viewIcons from "../../svg/viewIcons.svg";
import syncAppIcons from "../../svg/syncAppIcons.svg";

import {
  SEARCH_PANEL,
  GLOBAL_FILTER_PANEL,
  LOCAL_FILTER_PANEL,
  ENTITY_LIST_PANEL,
  MARKER_LIST_PANEL,
  ITEM_INSPECTOR_PANEL,
  MARKER_INSPECTOR_PANEL,
  SYNC_INSPECTOR_PANEL,
  TUTORIAL_PANEL,
  COLLAPSED_INSPECTOR_PANEL,
  HARVARD_SETTINGS_PANEL,
  SYNC_BINDER_PANEL,
  SETTINGS_PANEL,
  CONSTRAINT_PANEL,
  SCROLL_TO_DATE_PANEL,
  MENU_POPOVER_DATE,
  MENU_POPOVER_DURATION,
  MENU_POPOVER_SAVE_TEMPLATE_NAME,
  AEON_TOOLBAR
} from "../../constants/identifiers";
import CollapsedInspectorView from "../collapsedInspector";
import DateMenuPopover from "../../components/menuPopover/DateMenuPopover";
import DurationMenuPopover from "../../components/menuPopover/DurationMenuPopover";
import PrintPreviewModal from "../printPreviewModal";
import FileConflictsModal from "../fileConflictsModal";
import SyncItemInspector from "../syncItemInspector";
import EntityTreeView from "../entityList/EntityTreeView";
import { chooseValueForHarvard, wrapEditingComponent } from "../../utils/codeSplit";
import TextMenuPopover from "../../components/menuPopover/TextMenuPopover";
import ExportImagePreviewModal from "../exportImagePreviewModal";
// import RegistrationModal from "../registrationModal";
// import PurchaseModal from "../purchaseModal";
import FileVersionTooLowModal from "../fileVersionTooLowModal";
import FilterGroupPanel from "../filterPanel/FilterGroupPanel";
import SmartErrorBoundary from "../smartErrorBoundary";

import PropagateLoader from "react-spinners/PropagateLoader";
import { asPortalChild } from "../../components/portal/asPortalChild";
import NavigationToolbar from "../../components/navigationToolbar";
import ReleaseNotesModal from "../releaseNotesModal";

const createInlineSvg = () => (
  <div>
    <SVGInline svg={footerIcons} />
    <SVGInline svg={inspectorIcons} />
    <SVGInline svg={interfaceIcons} />
    <SVGInline svg={sidebarIcons} />
    <SVGInline svg={toolbarIcons} />
    <SVGInline svg={typeIcons} />
    <SVGInline svg={viewIcons} />
    <SVGInline svg={workviewIcons} />
    <SVGInline svg={settingsIcons} />
    <SVGInline svg={markerIcons} />
    <SVGInline svg={statusIcons} />
    <SVGInline svg={syncIcons} />
    <SVGInline svg={templateIcons} />
    <SVGInline svg={windowControlIcons} />
    <SVGInline svg={emptyState} />
    <SVGInline svg={syncAppIcons} />
  </div>
);

const TOOLBAR_ID = AEON_TOOLBAR;

const createLoadingDiv = () => (
  <div key="loader" className="iosAppLoading">
    <PropagateLoader size={15} color={"#ffffff"} />
  </div>
);

const createToolbar = onBackClick => <Toolbar domId={TOOLBAR_ID} key="toolbar" onBackClick={onBackClick} />;
const createSidebar = <Sidebar key="sidebar" />;
const createNotificationPanel = <NotificationPanel key="notificationPanel" />;

// const createRegistrationModal = <RegistrationModal key="registrationModal" />;
const createItemInspector = (showInspectorCollapse, onCollapseClick, collapseText) =>
  wrapEditingComponent(
    <SmartErrorBoundary key="itemInspector">
      <Inspector
        key="itemInspector"
        hideCollapse={!isNil(showInspectorCollapse) && !showInspectorCollapse}
        onCollapseClick={onCollapseClick}
        collapseText={collapseText}
      />
    </SmartErrorBoundary>
  );
const createMarkerInspector = <CalendarMarkerInspector key="markerInspector" />;
const createSyncItemInspector = <SyncItemInspector key="syncItemInspector" />;
const createTutorialPanel = <TutorialPanel key="tutorialPanel" />;
const createTutorialNotification = <TutorialNotification key="tutorialNotification" />;
const createCollapsedInspector = <CollapsedInspectorView key="collapsedInspector" />;

const createWorkspace = (canViewResize = true) => <Workspace key="layout" canViewResize={canViewResize} />;
const createFooter = <Footer key="footer" />;

const createSearchPanel = <SearchPanel key="searchPanel" />;
const createFilterPanel = chooseValueForHarvard(
  <FilterGroupPanel key="filterGroupPanel" />,
  <FilterPanel key="filterPanel" />
);
const createEntityList = <EntityTreeView key="entityList" />;
const createCalendarMarkerList = <CalendarMarkerList key="markerList" />;
const createSyncBinder = <SyncBinder key="syncBinder" />;
const createSettingsPanel = <SettingsPanel key="settingsPanel" />;
//#!if harvard === true
const createHarvardSettingsPanel = <HarvardSettingsPanel key="harvardSettingsPanel" />;
//#!endif
const createConstraintPanel = <ConstraintPanel key="constraintPanel" />;
const createScrollToDatePanel = onDateChange => (
  <ScrollToDatePanel key="scrollToDatePanel" onDateChange={onDateChange} />
);

const createInspectorPanelComponent = rightPanelMode => {
  switch (rightPanelMode) {
    case COLLAPSED_INSPECTOR_PANEL:
      return createCollapsedInspector;
    case TUTORIAL_PANEL:
      return createTutorialPanel;
    case MARKER_INSPECTOR_PANEL:
      return createMarkerInspector;
    case SYNC_INSPECTOR_PANEL:
      return createSyncItemInspector;
    default:
      return createItemInspector();
  }
};

const createInspectorPanel = rightPanelMode => {
  // return createInspectorPanelComponent(rightPanelMode);
  return <SmartErrorBoundary key="inspectorPanel">{createInspectorPanelComponent(rightPanelMode)}</SmartErrorBoundary>;
};

const createLeftPanelContent = (panelMode, showInspectorCollapse, onInspectorCollapseClick, collapseText) => {
  let panel = null;
  switch (panelMode) {
    case SEARCH_PANEL:
      return createSearchPanel;
    case GLOBAL_FILTER_PANEL:
    case LOCAL_FILTER_PANEL:
      return createFilterPanel;
    case ENTITY_LIST_PANEL:
      return createEntityList;
    case MARKER_LIST_PANEL:
      return createCalendarMarkerList;
    case SYNC_BINDER_PANEL:
      return createSyncBinder;
    case ITEM_INSPECTOR_PANEL:
      return createItemInspector(showInspectorCollapse, onInspectorCollapseClick, collapseText);
    case TUTORIAL_PANEL:
      return createTutorialPanel;
    case MARKER_INSPECTOR_PANEL:
      return createMarkerInspector;
    case SETTINGS_PANEL:
      return createSettingsPanel;
    //#!if harvard === true
    case HARVARD_SETTINGS_PANEL:
      return createHarvardSettingsPanel;
    //#!endif
    case CONSTRAINT_PANEL:
      panel = createConstraintPanel;
      break;
    case SCROLL_TO_DATE_PANEL:
      panel = createScrollToDatePanel();
      break;
  }

  return panel;
};

const createLeftPanelComponent = (
  panelMode,
  showInspectorCollapse,
  onInspectorCollapseClick,
  collapseText,
  key = "leftPanel"
) => {
  const content = createLeftPanelContent(panelMode, showInspectorCollapse, onInspectorCollapseClick, collapseText);
  return content ? <LeftPanel key={key}>{content}</LeftPanel> : null;
};

const createLeftPanel = (
  panelMode,
  floating,
  onHide,
  pageIndex,
  showInspectorCollapse,
  onInspectorCollapseClick,
  collapseText
) => {
  return (
    <SmartErrorBoundary key="leftPanelErrorBoundary">
      {createLeftPanelComponent(panelMode, showInspectorCollapse, onInspectorCollapseClick, collapseText)}
    </SmartErrorBoundary>
  );
};

const createLeftPanelPortalStack = (panelModes, showInspectorCollapse, onInspectorCollapseClick, collapseText) => {
  return map(panelModes, mode => {
    const child = mode
      ? createLeftPanelComponent(
        mode,
        showInspectorCollapse,
        onInspectorCollapseClick,
        collapseText,
        `leftPanel-${mode}`
      )
      : null;
    return child ? asPortalChild(child, `leftPanel-portalChild-${mode}`) : null;
  });
};

const getModal = (modalTitle, onCloseModal, children, modalKey) => (
  <SmartErrorBoundary key={modalKey} isModal={true} modalTitle={modalTitle} onCloseModal={onCloseModal}>
    {children}
  </SmartErrorBoundary>
);

const createSettingsModal = onCloseModal =>
  getModal("Settings", onCloseModal, <SettingsModal key="settings" />, "SettingsModalErrorBoundary");

const createPreferencesModal = onCloseModal =>
  getModal("Preferences", onCloseModal, <PreferencesModal key="preferences" />, "PreferenceModalErrorBoundary");
const createSyncSettingsModal = onCloseModal =>
  getModal("Sync Settings", onCloseModal, <SyncSettingsModal key="syncSettings" />, "SyncSettingsModalErrorBoundary");

const createBackupModal = onCloseModal =>
  getModal("Backup", onCloseModal, <BackupModal key="backupModal" />, "BackupModalErrorBoundary");
const createReleaseNotesModal = onCloseModal =>
  getModal(
    "Release Notes",
    onCloseModal,
    <ReleaseNotesModal key="releaseNotesModal" />,
    "ReleaseNotesModalErrorBoundary"
  );

const createPrintPreviewModal = onCloseModal => {
  //#!if harvard !== true
// return getModal(
// "Print Preview",
// onCloseModal,
// <PrintPreviewModal key="printPreview" />,
// "PrintPreviewModalErrorBoundary"
// );
  //#!endif
};
const createAboutModal = onCloseModal =>
  getModal("About", onCloseModal, <AboutModal key="about" />, "AboutModalErrorBoundary");
const createExportImagePreviewModal = onCloseModal =>
  getModal(
    "Export Image",
    onCloseModal,
    <ExportImagePreviewModal key="exportImage" />,
    "ExportImageModalErrorBoundary"
  );
const createExportTsfModal = onCloseModal =>
  getModal("Export TSF", onCloseModal, <ExportTsfModal key="exportTsf" />, "ExportTsfModalErrorBoundary");
const createExportCsvModal = onCloseModal =>
  getModal("Export CSV", onCloseModal, <ExportCsvModal key="exportCsv" />, "ExportCsvModalErrorBoundary");
const createImportCsvModal = onCloseModal =>
  getModal("Import CSV", onCloseModal, <ImportCsvModal key="importCsv" />, "ImportCsvModalErrorBoundary");
const createInspectorModal = onCloseModal =>
  getModal("Inspector", onCloseModal, <InspectorModal key="inspector" />, "InspectorModalErrorBoundary");
const createSaveTemplateModal = onCloseModal =>
  getModal(
    "Save Template",
    onCloseModal,
    <SaveTemplateModal key="saveTemplateModal" />,
    "SaveTemplateModalErrorBoundary"
  );
const createSampleModal = onCloseModal =>
  getModal("Sample", onCloseModal, <SampleModal key="sample" />, "SampleModalErrorBoundary");
const createFileConflictsModal = onCloseModal =>
  getModal(
    "File Conflicts",
    onCloseModal,
    <FileConflictsModal key="fileConflicts" />,
    "FileConflictsModalErrorBoundary"
  );
// const createPurchaseModal = () => <PurchaseModal key="purchase" />;
const createFileVersionTooLowModal = onCloseModal =>
  getModal(
    "File Version Too Low",
    onCloseModal,
    <FileVersionTooLowModal key="openFile" />,
    "FileVersionModalErrorBoundary"
  );
const createUpdateModal = onCloseModal =>
  getModal("Update", onCloseModal, <UpdateModal key="update" />, "UpdateModalErrorBoundary");

const createMenuPopover = (
  type,
  calendar,
  onClosePopover,
  onShiftItemsBy,
  onSaveCustomTemplate,
  dateRangeFrom,
  dateRangeTo
) => {
  let dateTarget = TOOLBAR_ID;
  //#!if harvard == true
  dateTarget = "app";
  //#!endif

  switch (type) {
    case MENU_POPOVER_DATE:
      return (
        <DateMenuPopover
          key="dateMenuPopover"
          calendar={calendar}
          title="Scroll to Date"
          buttonLabel="Scroll to Date"
          target={dateTarget}
          isOpen={true}
          onOk={date => {
            PubSub.publish(PubSubTopics.scrollToDate, date);
            onClosePopover();
          }}
          showCancel={true}
          onCancel={onClosePopover}
          dateRangeFrom={dateRangeFrom}
          dateRangeTo={dateRangeTo}
        />
      );
    case MENU_POPOVER_DURATION:
      return (
        <DurationMenuPopover
          key="durationMenuPopover"
          calendar={calendar}
          title="Shift Items by"
          target={TOOLBAR_ID}
          isOpen={true}
          onOk={duration => {
            onShiftItemsBy(duration);
            onClosePopover();
          }}
          onCancel={onClosePopover}
        />
      );
    case MENU_POPOVER_SAVE_TEMPLATE_NAME:
      return (
        <TextMenuPopover
          key="saveTemplateNameMenuPopover"
          title="Custom Template Name:"
          target={TOOLBAR_ID}
          isOpen={true}
          onOk={value => {
            onSaveCustomTemplate(value);
            onClosePopover();
          }}
          onCancel={onClosePopover}
        />
      );
    default:
      return null;
  }
};

const wrapInDragDropContainer = component => {
  let returnComponent = null;
  //#!if readonly !== true
// returnComponent = <DragAndDropContainer key="dragAndDropContainer">{component}</DragAndDropContainer>;
  //#!else
  returnComponent = component;
  //#!endif
  return returnComponent;
};

// Mobile

const getSplitViewConstraints = () => {
  let constraints = null;
  //#!if harvard === true
  constraints = selectors.getHarvardMobileToolbarSplitConstraints();
  //#!else
// constraints = selectors.getToolbarSplitConstraints(false);
  //#!endif

  return constraints;
};

const createSplitView = children => {
  const constraints = getSplitViewConstraints();

  return (
    <SplitView key="panelSplit" vertical={false} constraints={constraints}>
      {children}
    </SplitView>
  );
};

const createSplitViewWithPanelAndToolbar = (toolbar, panel) => {
  const wrapperStyle = { position: "relative", width: "100%", height: "100%" };
  const wrappedPanel = (
    <div style={wrapperStyle} key="panelWrapper">
      {panel}
    </div>
  );
  const children = [toolbar, wrappedPanel];
  return createSplitView(children);
};

const createSplitViewToolBar = (title, onBackClick, onNextClick, backText = "Back", nextText = "Go") => (
  <NavigationToolbar
    key="panelNavToolbar"
    title={title}
    showBack={true}
    onBackClick={onBackClick}
    backText={backText}
    showNext={!isNil(onNextClick)}
    onNextClick={onNextClick}
    nextText={nextText}
    flexLeft={1}
    flexCenter={3}
    flexRight={1}
  />
);

const createSplitViewWithPanel = (panel, onBackClick, title) => {
  const toolbar = createSplitViewToolBar(title, onBackClick);

  return createSplitViewWithPanelAndToolbar(toolbar, panel);
};

export default {
  TOOLBAR_ID,

  wrapInDragDropContainer,

  createInlineSvg,
  createLoadingDiv,
  createToolbar,
  createSidebar,
  createNotificationPanel,
  createItemInspector,
  createMarkerInspector,
  createTutorialPanel,
  createTutorialNotification,
  createCollapsedInspector,
  createWorkspace,
  createFooter,
  createInspectorPanel,
  createEntityList,
  createLeftPanel,
  createLeftPanelPortalStack,
  createSettingsModal,
  createPreferencesModal,
  createSyncSettingsModal,
  createBackupModal,
  createAboutModal,
  createFileVersionTooLowModal,
  createExportImagePreviewModal,
  createExportTsfModal,
  createExportCsvModal,
  createImportCsvModal,
  createSaveTemplateModal,
  createInspectorModal,
  createPrintPreviewModal,
  createSampleModal,
  createFileConflictsModal,
  createMenuPopover,
  createFilterPanel,
  createSearchPanel,
  createSettingsPanel,
  //#!if harvard === true
  createHarvardSettingsPanel,
  //#!endif
  createScrollToDatePanel,
  createUpdateModal,
  createReleaseNotesModal,

  // Mobile
  createSplitViewWithPanel,
  createSplitViewWithPanelAndToolbar,
  createSplitViewToolBar
};
